import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { getIcon } from "./iconRegistry";

// ---------------------------------------------------------------------------
// iconKit/renderIconSvgMarkup — convertit une icône du registre en une
// chaîne HTML <svg>...</svg> réelle, pour les contextes d'export statique
// (ex. PageBuilder's buildSiteHtml) où il n'y a pas d'arbre React monté.
//
// Utilise `react-dom/server`'s `renderToStaticMarkup` — la façon supportée
// et stable-dans-le-temps d'obtenir le markup d'un composant lucide-react /
// react-icons, plutôt que de dépendre de la structure interne non
// documentée de ces librairies (qui pourrait changer sans préavis).
// `renderToStaticMarkup` fonctionne aussi bien côté navigateur que Node —
// pas besoin d'environnement serveur pour l'utiliser ici.
//
// Retourne "" (chaîne vide) si l'iconId est inconnu — l'appelant doit alors
// retomber sur le rendu de secours (glyphe), jamais injecter de markup vide
// à la place d'un élément visible.
// ---------------------------------------------------------------------------
export function renderIconSvgMarkup(iconId, {
  width = "100%",
  height = "100%",
  color,
  rotation,
  opacity,
  decorative = true,
  ariaLabel,
} = {}) {
  const icon = getIcon(iconId);
  if (!icon) return "";

  const style = {};
  if (rotation) style.transform = `rotate(${rotation}deg)`;
  if (opacity != null) style.opacity = opacity;

  const svgProps = {
    width,
    height,
    ...(color ? { color } : {}),
    ...(Object.keys(style).length ? { style } : {}),
    ...(decorative ? { "aria-hidden": "true" } : { role: "img", "aria-label": ariaLabel || icon.label }),
  };

  return renderToStaticMarkup(React.createElement(icon.Component, svgProps));
}
